/**
 * Use case pour s'abonner en temps réel à un post spécifique
 * Sert de pont entre l'infrastructure Firebase et le domaine
 */
export default class SubscribeToPost {
  constructor(postRepository) {
    this.postRepository = postRepository;
  }

  /**
   * Établit un abonnement temps réel à un post spécifique
   * @param {Object} options 
   * @param {string} options.postId - ID du post à écouter
   * @param {Function} options.onUpdate - Callback appelé quand le post est mis à jour
   * @param {Function} options.onError - Callback appelé en cas d'erreur
   * @returns {Function} - Fonction pour désabonner
   */
  async execute({ postId, onUpdate, onError }) {
    try {
      if (!postId) {
        throw new Error('postId is required');
      }

      // Utiliser le repository pour s'abonner au post
      const unsubscribe = await this.postRepository.subscribeToPost({
        postId,
        onUpdate,
        onError
      });

      return unsubscribe;
    } catch (error) {
      onError(error);
      return () => {}; // Return empty unsubscribe function
    }
  }
} 